
export const GET_DATA_LOADING = 'GET_DATA_LOADING';
export const GET_DATA_SUCCESS = 'GET_DATA_SUCESS';
export const GET_DATA_ERROR = 'GET_DATA_ERROR';